"use client";

import { Content } from "@/services/content/types";
import { prefixSlug } from "@/utils/url";
import Link from "next/link";
import { Fragment, useEffect, useState } from "react";
import Marquee from "react-fast-marquee";

const Dot = () => (
  <span className="inline-block h-2 w-2 rounded-full bg-red-700 mx-4 shrink-0" />
);

type ClientProps = {
  articles: Content.Section[];
  title?: string;
};

const formatSwedishDate = () => {
  const now = new Date();
  const weekday = new Intl.DateTimeFormat("sv-SE", {
    weekday: "long",
    timeZone: "Europe/Stockholm",
  }).format(now);
  const day = new Intl.DateTimeFormat("sv-SE", {
    day: "numeric",
    timeZone: "Europe/Stockholm",
  }).format(now);
  const month = new Intl.DateTimeFormat("sv-SE", {
    month: "long",
    timeZone: "Europe/Stockholm",
  }).format(now);

  const capitalizedWeekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);

  return `${capitalizedWeekday} ${day} ${month.charAt(0).toUpperCase() + month.slice(1)}`;
};

const Client = (props: ClientProps) => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return (
    <div className="border-b border-sand-700 bg-sand-700">
      <div className="flex items-center container px-0">
        {props.title && (
          <span className="shrink-0 py-3 font-bold px-2 md:pl-0 text-sm md:text-base text-red-700">
            {props.title}:
          </span>
        )}

        <div className="flex-1 overflow-hidden relative after:pointer-events-none after:h-full after:w-[30px] after:absolute after:right-0 after:top-0 after:bg-gradient-to-r after:to-sand-700 after:from-transparent after:z-10 before:pointer-events-none before:h-full before:w-[15px] before:absolute before:left-0 before:top-0 before:bg-gradient-to-l before:to-sand-700 before:from-transparent before:z-10">
          {mounted && (
            <Marquee pauseOnHover speed={40}>
              <div className="flex items-center">
                {props.articles
                  .filter((article) => {
                    const fields = article.fields as any;
                    return fields.teaserTitle || fields.title;
                  })
                  .map((article, index) => {
                    const fields = article.fields as any;
                    const slug = fields.slug;
                    const title = fields.title || fields.teaserTitle;
                    const contentType = article.sys.contentType?.sys?.id;

                    return (
                      <Fragment key={article.sys.id}>
                        {index > 0 && <Dot />}
                        {slug ? (
                          <Link
                            href={prefixSlug(slug, contentType)}
                            className="whitespace-nowrap font-noto font-semibold hover:underline py-3"
                          >
                            {title}
                          </Link>
                        ) : (
                          <span className="whitespace-nowrap font-noto font-semibold">
                            {title}
                          </span>
                        )}
                      </Fragment>
                    );
                  })}
                <Dot />
              </div>
            </Marquee>
          )}
        </div>
      </div>
    </div>
  );
};

export default Client;
